import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import 'moment/locale/de';
import { Snackbar } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import {
  fetchBookingsHistory,
  fetchContentLibrary,
  fetchTopics,
  fetchUpcomingEvents,
  fetchUser,
  selectUser,
  useAppDispatch,
} from '../../../store';
import Alert from '../../shared/notification/Alert';
import { addToastInfo, selectCommon } from '../../../store/common';
import { fetchRecommendedMentors } from '../../../store/recommendedMentors';

export const LikeMindedApp = () => {
  const { user, status } = useSelector(selectUser);
  const { toast } = useSelector(selectCommon);
  const history = useHistory();
  const [, i18n] = useTranslation();
  const dispatch = useAppDispatch();
  const location = useLocation();
  const { id } = { ...user };
  const { pathname } = location;
  const { language } = i18n;

  useEffect(() => {
    if (language === 'de') {
      moment.updateLocale('de', {
        weekdaysShort: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
      });
    } else {
      moment.locale(language);
    }
  }, [language]);

  useEffect(() => {
    if (window.analytics && id) {
      window.analytics.identify(id, {
        language: i18n.language,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, pathname]);

  useEffect(() => {
    dispatch(fetchUser());
    dispatch(fetchTopics());

    dispatch(fetchBookingsHistory());
    dispatch(fetchUpcomingEvents());
    dispatch(fetchContentLibrary());
    dispatch(fetchRecommendedMentors());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    dispatch(fetchContentLibrary());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [language]);

  useEffect(() => {
    if (status === 'logged_out') {
      history.push('/logout');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status]);

  const onSnackbarClose = () => {
    dispatch(addToastInfo({ toastInfo: { open: false } }));
  };

  return (
    <>
      <Snackbar
        open={toast?.open}
        autoHideDuration={3000}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        onClose={onSnackbarClose}
      >
        {/* @ts-ignore next */}
        <Alert
          variant="outlined"
          severity={toast?.type}
          onClose={onSnackbarClose}
        >
          {toast?.content}
        </Alert>
      </Snackbar>
    </>
  );
};
